import { peso } from '../utils/formatCurrency';

// Money that is part of the total collected but is not one of the listed fees (a discount, or a
// category that is no longer in the fee list), so the category lines always add up to the total.
function CategoryAdjustments({ discount, other }) {
  if (!discount && !other) return null;

  return (
    <div className="mt-4 space-y-1 border-t border-gray-100 pt-3 text-sm">
      {discount !== 0 && (
        <div className="flex justify-between gap-2">
          <span className="font-medium text-gray-800">Discount</span>
          <span className="whitespace-nowrap text-gray-700">{peso(discount)}</span>
        </div>
      )}
      {other !== 0 && (
        <div className="flex justify-between gap-2">
          <span className="font-medium text-gray-800">Other categories</span>
          <span className="whitespace-nowrap text-gray-700">{peso(other)}</span>
        </div>
      )}
    </div>
  );
}

export default CategoryAdjustments;
